module.exports = "data:image/gif;base64,R0lGODlhCQAFAJECAImJiezs7P///wAAACH5BAEAAAIALAAAAAAJAAUAAAIMDI4QYrnC0INxUnYLADs="


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/grid/sort_desc.gif
 ** module id = 434
 ** module chunks = 0
 **/